import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "ui-button inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap text-sm font-semibold tracking-[-0.01em] transition-[transform,background-color,border-color,color,box-shadow] duration-150 ease-apple focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background active:scale-[0.97] motion-reduce:active:scale-100 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "ui-button-primary bg-primary text-primary-foreground shadow-[0_1px_2px_hsl(var(--primary)/0.22),0_1px_1px_hsl(var(--primary)/0.12)]",
        destructive:
          "ui-button-destructive bg-destructive text-destructive-foreground shadow-[0_1px_2px_hsl(var(--destructive)/0.2)]",
        outline:
          "ui-button-outline border border-input bg-background/80 shadow-[0_1px_2px_hsl(var(--foreground)/0.04)]",
        secondary:
          "ui-button-secondary bg-secondary text-secondary-foreground shadow-[0_1px_2px_hsl(var(--foreground)/0.04)]",
        ghost: "ui-button-ghost",
        link: "ui-button-link text-primary underline-offset-4",
        success: "ui-button-success bg-[hsl(var(--success))] text-[hsl(var(--success-foreground))] shadow-[0_1px_2px_hsl(var(--success)/0.2)]",
        warning: "ui-button-warning bg-[hsl(var(--warning))] text-[hsl(var(--warning-foreground))] shadow-[0_1px_2px_hsl(var(--warning)/0.2)]",
      },
      size: {
        default: "h-9 px-4",
        sm: "h-8 px-3 text-xs",
        lg: "h-10 px-5",
        icon: "h-9 w-9",
      },
      shape: {
        default: "rounded-lg",
        pill: "rounded-full",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
      shape: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
